export default __webpack_public_path__ + "static/media/scroll4.cf107df8.jpg";